import { render, staticRenderFns } from "./AddPessoasexoPage.vue?vue&type=template&id=09301916&"
import script from "./AddPessoasexoPage.vue?vue&type=script&lang=js&"
export * from "./AddPessoasexoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports